import React from "react";

import { Auth } from "../../../context/admin/Authentication";

import Screen from "../../home/content/Screen";

import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";
import Detail from "./Details";

import { DoSeeDataProvider } from "../../../context/doSeeData/DoSeeDataContext";
import { CountryProvider } from "../../../context/country/countryContext/CountryContext";
import { PositionProvider } from "../../../context/position/PositionContext";

export const Restaurant = () => {
  return (
    <DoSeeDataProvider>
      <PositionProvider>
        <Auth
          children={
            <Screen
              component={<Overview />}
              title="Restaurant"
            />
          }
        />
      </PositionProvider>
    </DoSeeDataProvider>
  );
};

export const AddRestaurant = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Add />}
              title="Add Restaurant"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};

export const EditRestaurant = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Edit />}
              title="Edit Restaurant"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};

export const ViewRestaurant = () => {
  return (
    <DoSeeDataProvider>
      <Auth
        children={
          <Screen
            component={<Detail />}
            title="Restaurant Details"
          />
        }
      />
    </DoSeeDataProvider>
  );
};
